module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/Manage/products/product-form/product-form.component.css
// module id = ./src/app/Pages/Manage/products/product-form/product-form.component.css
// module chunks = main